// extracted by mini-css-extract-plugin
export default {"star-icon":"_67xhjw","starIcon":"_67xhjw","rating":"_8ba1zp"};